"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useButtonStyle = () => {
    const buttonStyles = {
        padding: '8px 24px 8px 24px',
        textTransform: 'none',
        minHeight: '40px',
        '.wrapper': {
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
        },
    };
    return { buttonStyles };
};
exports.default = useButtonStyle;
